import { BubbleFormPage } from '@go-client/components/BubbleUI/BubbleForm';
import { GroupBooking, VenueRequestFile } from '@go-shared/types/groupBooking';
import { Property } from '@go-shared/types/property';
import React from 'react';
import { GroupBookingDataBundle, GroupBookingFormWorkflow, GroupForm, submitGroupForm } from '.';
import EnterGroupPage from '../EnterGroupPage';
import { BrandGroupType } from '@go-shared/types/brand';
import { useUserInfo } from '@go-client/context/UserInfoContext';

interface EditGroupWorkflowPrereqs {
  selectedGroup?: GroupBooking;
  groupForm: GroupForm;
  setGroupForm: React.Dispatch<React.SetStateAction<GroupForm>>;
  changeGroupFormAttribute: <T extends keyof GroupForm>(key: T, val: GroupForm[T]) => void;
  property: Property;
  groupTypes: BrandGroupType[];
  handleGroupUploadFile: (file: File) => void;
  handleGroupUpdateFile: (file: VenueRequestFile) => void;
  handleGroupDeleteFile: (file: VenueRequestFile) => void;
  onClose?: () => void;
  onSubmitBooking?: () => void;
}

export default function buildEditGroupWorkflow(
  pages: Array<BubbleFormPage<GroupBookingDataBundle>>,
  preqs: EditGroupWorkflowPrereqs
): GroupBookingFormWorkflow {
  const { user } = useUserInfo();
  async function handleSubmitGroupForm() {
    await submitGroupForm({
      selectedGroup: preqs.selectedGroup,
      groupForm: preqs.groupForm,
      propertyId: preqs.property._id,
      brand: preqs.property.brand,
      user,
    });

    if (preqs.onSubmitBooking) preqs.onSubmitBooking();
    if (preqs.onClose) preqs.onClose();
  }

  pages.push({
    key: 'group-edit-page-1',
    render: () => (
      <EnterGroupPage
        title={preqs.selectedGroup ? 'Edit Group' : 'Create Group'}
        groupForm={preqs.groupForm}
        changeGroupForm={preqs.changeGroupFormAttribute}
        groupTypeOpts={preqs.groupTypes}
        onUpdateFile={preqs.handleGroupUpdateFile}
        onUploadFile={preqs.handleGroupUploadFile}
        onDeleteFile={preqs.handleGroupDeleteFile}
        onClose={preqs.onClose}
        onSubmitGroupDetails={handleSubmitGroupForm}
      />
    ),
  });

  return {};
}
